class Speedtracker {
  constructor() {
    this.lastTime = Date.now();
    this.lastValue = 0;
    this.__speed = 0;
  }
  set value(val) {
    this.__speed = (val - this.lastValue) / (Date.now() - this.lastTime);
    this.lastValue = val;
    this.lastTime = Date.now();
  }
  get speed() {
    return this.__speed;
  }
}
export {
  Speedtracker
};
